import { lazy, Suspense } from 'react';

import { Loading } from './loading';

const TripPlanner = lazy(() => import('./trip-planner'));

export function TripPlannerPage() {
  return (
    <Suspense fallback={<Loading />}>
      <TripPlanner />
    </Suspense>
  );
}
